import React, { useEffect, useState } from "react";

const RadioOptions = ({
  options = [],
  selectedValue,
  parentLabel = "",
  inputProps,
  inputClass = "",
  parentClass = "",
  labelClass = "",
}) => {
  if (inputProps.id) delete inputProps.id;
  if (inputProps.key) delete inputProps.key;
  if (inputProps.value) delete inputProps.value;
  if (inputProps.label) delete inputProps.label;
  if (inputProps.checked) delete inputProps.checked;
  if (inputProps.className) delete inputProps.className;

  return (
    options.length > 0 && (
      <div className="sim-radio-input">
        <p className="main-label">{parentLabel}</p>
        <div className="options-list">
          {options.map((item) => (
            <div key={item?.value} className={`form-check ${parentClass}`}>
              <input
                className={`form-check-input ${inputClass}`}
                type="checkbox"
                id={item?.key}
                checked={item?.value === selectedValue}
                {...inputProps}
              />
              <label className={`form-check-label ${labelClass}`} htmlFor={item?.key}>
                {item?.label || ""}
              </label>
            </div>
          ))}
        </div>
      </div>
    )
  );
};

export default RadioOptions;
